import React from 'react';

const Logo = () => {
  return (
    <div>
      <img
        src='https://res.cloudinary.com/belong/image/upload/v1638202033/uploaded_resources/Belong_logo_qiv6fv.png'
        alt='Belong'
        className='hidden md:block w-48'
      />
      <img
        src='https://res.cloudinary.com/belong/image/upload/v1643351815/uploaded_resources/logo-small_mtbkf0.png'
        alt='Belong'
        className='md:hidden w-16'
      />
    </div>
  );
};

export default Logo;
